var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 210H45c-8.291 0-15-6.709-15-15v-60c0-24.814 20.186-45 45-45h30c8.291 0 15 6.709 15 15v90c0 8.291-6.709 15-15 15z",
    fill: "#57555c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482 195c0 8.291-6.709 15-15 15h-60c-8.291 0-15-6.709-15-15l-30-90c0-8.291 6.709-15 15-15h60c24.814 0 45 20.186 45 45v60z",
    fill: "#3c3a41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M422 120v75c0 8.399-6.599 15-15 15H105c-8.401 0-15-6.601-15-15V15c0-8.401 6.599-15 15-15h197l30 90 90 30z",
    fill: "#e5e5e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407 210H256V0h46l30 90 90 30v75c0 8.399-6.599 15-15 15z",
    fill: "#d9d9d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M467 180H45c-24.901 0-45 20.099-45 45v182c0 24.899 20.099 45 45 45h422c24.901 0 45-20.101 45-45V225c0-24.901-20.099-45-45-45z",
    fill: "#1ba9ef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302 105c0 8.399 6.599 15 15 15h105L302 0v105z",
    fill: "#fe9923"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 225v182c0 24.899-20.099 45-45 45H256V180h211c24.901 0 45 20.099 45 45z",
    fill: "#1689fc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 270H75c-8.291 0-15-6.709-15-15s6.709-15 15-15h30c8.291 0 15 6.709 15 15s-6.709 15-15 15z",
    fill: "#e1e4fb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422 319.999V497c0 8.399-6.599 15-15 15H105c-8.401 0-15-6.601-15-15V319.999h332z",
    fill: "#e5e5e5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422 319.999V497c0 8.399-6.599 15-15 15H256V319.999h166z",
    fill: "#d9d9d9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#aeadb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362 377c0 8.399-6.599 15-15 15H165c-8.401 0-15-6.601-15-15 0-8.401 6.599-15 15-15h182c8.401 0 15 6.599 15 15zM362 437c0 8.399-6.599 15-15 15H165c-8.401 0-15-6.601-15-15 0-8.401 6.599-15 15-15h182c8.401 0 15 6.599 15 15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#8b8892"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362 437c0 8.399-6.599 15-15 15h-91v-30h91c8.401 0 15 6.599 15 15zM362 377c0 8.399-6.599 15-15 15h-91v-30h91c8.401 0 15 6.599 15 15z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M452 317c0 8.399-6.599 15-15 15H75c-8.401 0-15-6.601-15-15 0-8.401 6.599-15 15-15h362c8.401 0 15 6.599 15 15z",
    fill: "#57555c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M452 317c0 8.399-6.599 15-15 15H256v-30h181c8.401 0 15 6.599 15 15z",
    fill: "#3c3a41"
  })));
}

export default __webpack_public_path__ + "7ac1cd84a8885cb63175828845281278.svg";
export { SvgPrinter as ReactComponent };